<template>
  <div class="pb-30">
    <ContentSection skew="right" id="our-people" class="z-0 bg-regalblue-500 pb-16 pt-16">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 sm:col-span-10">
          <h1 class="text-4xl text-white">CI Synchronizer Support</h1>
          <p class="pb-2 text-xl sm:text-2xl font-light text-white">
            Last Updated: 22th January 2021
          </p>
        </div>
      </div>
    </ContentSection>
    <ContentSection id="eula" skew="right" class="z-10 bg-white my-0 pt-16 pb-24">
      <div class="eula-wrap">
        <span>
          For any support enquiries, please email us here:
          <a
            class="text-grey-700 underline hover:text-astralblue-700"
            href="mailto:cisynchronizer@pipefish.com.au?subject=CI Synchronizer Support"
          >
            cisynchronizer@pipefish.com.au
          </a>
        </span>
      </div>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/ContentSection.vue';

export default {
  name: 'HomeCallout',
  components: {
    ContentSection
  }
};
</script>

<style lang="scss"></style>
